module.exports = __webpack_public_path__ + "img/logo.e9d29916.png";